module.exports = __webpack_public_path__ + "static/media/ic_advertising_blue.3c1e1d4a.svg";